import { render, staticRenderFns } from "./DeliverHome.vue?vue&type=template&id=5711f585&scoped=true"
import script from "./DeliverHome.vue?vue&type=script&lang=js"
export * from "./DeliverHome.vue?vue&type=script&lang=js"
import style0 from "./DeliverHome.vue?vue&type=style&index=0&id=5711f585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711f585",
  null
  
)

export default component.exports